module.exports = __webpack_public_path__ + "assets/img/17_1427.ed54d187.jpg";